import React from 'react'

import { useTheme } from '@mui/material'

import TableCell from 'components_new/atoms/Table/TableCell'
import TableSortLabel from 'components_new/atoms/Table/TableSortLabel'

import {
  // ellipseLabel,
  getCellAlignment,
  getCellScaleSx,
  getStickyCellSx
} from '../utils'
import { TableDataType } from '../index'

interface HeaderCellProps {
  divider: boolean
  label: string
  measureRef?: (cell: HTMLTableCellElement | null) => void
  scaleFactor: number
  type: TableDataType
  active: boolean
  onClick?: () => void
  order?: 'asc' | 'desc'
  // set on a pinned column: how far from the edge it sits
  stickyLeft?: number
  // Next release:
  // numberOfCharacters?: number
}

const HeaderCell = (props: HeaderCellProps) => {
  const {
    divider,
    label,
    measureRef,
    scaleFactor,
    type,
    active,
    onClick,
    order,
    stickyLeft
    // numberOfCharacters
  } = props

  const theme = useTheme()

  return (
    <TableCell
      align={getCellAlignment(type)}
      ref={measureRef}
      sx={{
        borderRight: divider ? '1px solid' : undefined,
        '&:last-child': { borderRight: 0 },
        borderRightColor: 'divider',
        whiteSpace: 'nowrap',
        width: '1%', // For auto sized, fit content cells. (Hacker).
        ...getCellScaleSx(scaleFactor),
        ...(stickyLeft !== undefined
          ? getStickyCellSx(theme, true, stickyLeft)
          : undefined)
      }}
      sortDirection={active ? order : false}
      variant="head"
    >
      {onClick ? (
        <TableSortLabel
          active={active}
          direction={order}
          onClick={(e) => {
            e.stopPropagation()
            e.preventDefault()

            onClick()
          }}
          onMouseDown={(e) => {
            e.stopPropagation()
            e.preventDefault()
          }}
          sx={{
            fontSize: 'inherit',
            '& svg': {
              fontSize: '1.25em'
            }
          }}
        >
          {label}
          {/* ellipseLabel(label, numberOfCharacters) */}
        </TableSortLabel>
      ) : (
        label
      )}
    </TableCell>
  )
}

export default HeaderCell
